import styled from "styled-components";
import { device } from "../../styles/mediaQueries";

export const Wrapper = styled.main`
  margin: 0 0.7rem;

  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 10px;

  @media (${device.tablet}) {
    max-width: 1080px;
    padding: 20px 0.7rem;
    margin: auto;
  }
`;
